// @flow

import { NoiseSuppressionEffect } from 'store/modules/stream-effects/noise-suppression/NoiseSuppressionEffect';
import {
  createVirtualBackgroundEffect,
  enableSensoringEffect
} from 'store/modules/stream-effects/virtual-background';

import logger from './logger';
import { sensoringEnabled } from 'store/modules/virtual-background/actions';

/**
 * Loads the enabled stream effects.
 *
 * @param {Object} store - The Redux store.
 * @returns {Promsie} - A Promise which resolves when all effects are created.
 */
export default function loadEffects(store) {
  const state = store.getState();
  const virtualBackground = state['feature/virtual-background'];
  const noiseSuppression = state['features/noise-suppression'];
  const device = state['features/login'].user?.device;
  const { noiseSuppression: nsOptions } = state['features/base/config'];

  const backgroundPromise = virtualBackground.backgroundEffectEnabled
    ? createVirtualBackgroundEffect(virtualBackground).catch((error) => {
        logger.error(
          'Failed to obtain the background effect instance with error: ',
          error
        );

        return Promise.resolve();
      })
    : Promise.resolve();

  const noiseSuppressionPromise = noiseSuppression?.enabled
    ? Promise.resolve(new NoiseSuppressionEffect(nsOptions))
    : Promise.resolve();
  store.dispatch(sensoringEnabled(device?.options?.enableCensorship === 1));
  const sensoringEffectPromise =
    device?.options?.enableCensorship === 1
      ? enableSensoringEffect(state).catch((error) => {
          logger.error(error);
          return Promise.resolve();
        })
      : Promise.resolve();
  return Promise.all([
    backgroundPromise,
    noiseSuppressionPromise,
    sensoringEffectPromise
  ]);
}
